module.exports = __webpack_public_path__ + "img/icon_check.f8ffe22c.svg";